export default __webpack_public_path__ + "static/media/19.98673190.png";